import { parseUrl, useWPApi, wpApi } from '@gik/core/api';
import { ConfigInterface, responseInterface } from 'swr';
import { ICalendarAnnouncementType } from '@gik/calendar/models/CalendarAnnouncement';
import { WordpressError } from '@gik/core/models/wordpress/WordpressError';

const path = 'announcement-type';

function getParams() {
  return {
    _fields: 'id,name,slug,acf.color_palette,acf.icon,acf.sort_order',
  };
}

export function getCalendarAnnouncementTypes() {
  const finalUrl = parseUrl(path, {
    searchParams: getParams(),
  });
  return wpApi.get(finalUrl);
}

export function useCalendarAnnouncementTypes<Data = ICalendarAnnouncementType[], Error = WordpressError>(
  config?: ConfigInterface
): responseInterface<Data, Error> {
  return useWPApi<Data, Error>(path, config, {
    deepQueryParams: getParams(),
  });
}
